import React, { useState } from 'react'
import { Wrapper } from './style'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { PlanTypes } from 'src/redux/types/planTypes'
import { ModalButton } from 'src/components/Global/Button/Button'
import Select from 'react-select'
import { XContestTypes } from 'src/redux/types/xContest'

const AutomatedSavings = () => {
  const [planData, setPlanData] = useState({
    saving_frequency: '',
    auto_debit_amount: '',
    saving_type: 'automated',
    main_card: 'new',
  })
  const { auto_debit_amount } = planData

  const options = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
  ]
  const style = {
    control: (base: any) => ({
      ...base,
      border: 0,
      boxShadow: 'none',
    }),
  }
  const handleOption = (options: any) => {
    planData.saving_frequency = options.value
    dispatch(action(XContestTypes.CONTEST_FORM_DATA, planData))
  }

  let location = useLocation()
  const dispatch = useDispatch()

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...planData }
    newData[name] = value
    setPlanData(newData)
    dispatch(action(XContestTypes.CONTEST_FORM_DATA, newData))
  }
  return (
    <Wrapper>
      <div className="pageNumber"></div>
      <form className="content">
        <div className="top-form">
          <h2 className="title">Savings Frequency</h2>
          <p className="desc">How often do you want to save?</p>
          <QuicksaveInput
            type="number"
            name="auto_debit_amount"
            value={auto_debit_amount}
            placeholder="100,000"
            onChange={handleChange}
          />
          <div className="form-group">
            <Select
              placeholder="Frequency Of Savings"
              options={options}
              onChange={handleOption}
              className="filter_select"
              styles={style}
            />
          </div>
        </div>
        <div>
          <Link
            to={`/contest-checkout`}
            state={{ backgroundLocation: location }}
          >
            <ModalButton className="button">Continue</ModalButton>
          </Link>
        </div>
      </form>
    </Wrapper>
  )
}

export { AutomatedSavings }
